<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">活动记录</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 300px;">


        <div v-for="(item,i) in list" :key="i" style="padding: 10px;">

          <div style="padding: 10px 0px;">
            {{item.text}}

            <el-button style="float: right;" type="text"
                       @click="del(item.text,item.activityOrderRecordCode)">删除</el-button>

            <el-button style="float: right;margin-right: 10px;" type="text"
                       @click="edit(item.text,item.activityOrderRecordCode)">编辑</el-button>

          </div>
          <div v-for="(item2,ii) in item.listActivityOrderRecordImg" :key="ii">
            <el-image :src="imgUrl+item2.imgPath" style="width: 100%;"/>
          </div>

          <div style="border-bottom:1px solid #eee; "></div>

        </div>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="add">新增</el-button>
      </div>
    </div>



    <PhotoAdd ref="myPhotoAdd" v-show="showModalPhotoAdd" v-on:closePhotoAdd="closePhotoAdd" v-on:getPhotoList="getPhotoList"></PhotoAdd>
    <PhotoEdit ref="myPhotoEdit" v-show="showModalPhotoEdit" v-on:closePhotoEdit="closePhotoEdit" v-on:getPhotoList="getPhotoList"></PhotoEdit>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import PhotoAdd from "./PhotoAdd";
import PhotoEdit from "./PhotoEdit";

export default {
  name: 'Photo',
  props: [],
  data() {
    return {

      loading: false,

      activityOrderCode:'',

      list:[],
      imgUrl:this.$imgUrl,

      showModalPhotoEdit:false,
      showModalPhotoAdd:false,


    }
  },
  components:{
    PhotoEdit,PhotoAdd
  },
  methods: {
    init(row){

      this.activityOrderCode = row.activityOrderCode;

      this.getPhotoList();

    },

    closeSelf() {
      this.loading= false
      this.$emit("closePhoto");
    },
    closePhotoEdit(){
      this.showModalPhotoEdit = !this.showModalPhotoEdit;
    },
    closePhotoAdd(){
      this.showModalPhotoAdd = !this.showModalPhotoAdd;
    },

    del(name,code){

      let that = this;
      this.$confirm('确定删除"'+name+'"吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.del_do(code);
      }).catch(e=>e)
    },

    add(){
      this.showModalPhotoAdd = !this.showModalPhotoAdd;
      this.$refs.myPhotoAdd.init(this.activityOrderCode);
    },
    edit(name,code){
     console.log(name,code);

     this.showModalPhotoEdit = !this.showModalPhotoEdit;
     this.$refs.myPhotoEdit.init(code);

    },


    getPhotoList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrderRecord/Get',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          activityOrderCode:this.activityOrderCode,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.list = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    del_do(code){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrderRecord/Delete',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          activityOrderRecordCode:code,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){

          let arr = [];
          for(let i=0;i<this.list.length;i++){
            if(this.list[i].activityOrderRecordCode != code){
              arr.push(this.list[i]);
            }
          }
          this.list = arr;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

  }
}
</script>

